import { Location } from 'history';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { getRouterState } from '../../../global/selectors';
import { LocationState } from '../../../global/types';
import { defaultSortOrder } from '../constants';
import { CollectionsSortOrder } from '../types';

type CollectionsQueryParams = {
  location: Location<LocationState>;
  locationState: LocationState;
  search: string;
  sortOrder: CollectionsSortOrder;
  start: number;
};

const parseOrdersSortOrder = (sort: string): CollectionsSortOrder => {
  const sortOrders = Object.values(CollectionsSortOrder);
  return sortOrders.includes(sort as CollectionsSortOrder)
    ? (sort as CollectionsSortOrder)
    : defaultSortOrder;
};

const useCollectionsQueryParams = (): CollectionsQueryParams => {
  const { location } = useSelector(getRouterState);
  const parsed = queryString.parse(location.search);
  const start: number = parsed.start ? parseInt(parsed.start.toString(), 10) : 0;
  const search: string = parsed.search ? parsed.search.toString() : '';
  const sortOrder = parseOrdersSortOrder(parsed.sort ? parsed.sort.toString() : '');
  const { state } = location;

  return {
    location,
    locationState: state,
    search,
    sortOrder,
    start,
  };
};

export default useCollectionsQueryParams;
